import { useNavigate, useParams } from "react-router-dom";

import { useFindOwnerEntity, useUpdateOwnerEntity } from "pages/PitPort/OwnerEntity/api";
import BaseOwnerEntityForm from "pages/PitPort/OwnerEntity/BaseOwnerEntityForm";

const EditOwnerEntity = () => {
  const { id: ownerEntityId } = useParams();
  const navigate = useNavigate();
  const { update } = useUpdateOwnerEntity();
  const { data: ownerEntity } = useFindOwnerEntity({ ownerEntityId: ownerEntityId as string });

  const handleSubmit = async (data: {
    name: string;
    address: string;
    tel: string;
    email: string;
    type: PitPortOwnerEntityType;
    profitShareRate: number;
  }) => {
    return await update({
      id: ownerEntityId as string,
      ...data,
    });
  };

  return (
    <BaseOwnerEntityForm
      mode="edit"
      initialData={ownerEntity?.data}
      onSubmit={handleSubmit}
      onCancel={() => navigate("/pit_port/owner-entities")}
      breadcrumbItems={[{ pageName: "貸主", onClick: () => navigate("/pit_port/owner-entities") }]}
      currentPageName="貸主情報を編集"
    />
  );
};

export default EditOwnerEntity;
